import React, { ReactNode } from 'react';

interface FilterProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
}
const Filter: React.FC<FilterProps> = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="flex absolute top-[50px] right-0 justify-center items-center z-[1000] w-[327px]">
            <div className="relative flex flex-col items-center justify-around w-full gap-3 p-4 px-3 bg-white border border-light-gray rounded-[4px] shadow-[0px_7px_9px_rgba(141,141,141,0.10),_0px_4px_13px_rgba(141,141,141,0.08)] overflow-hidden">
                <button
                    className="absolute flex top-0 right-0 w-[20px] h-[10px] bg-white rounded-[16px] m-0 p-0 text-3xl"
                    onClick={onClose}
                >
                    &times;
                </button>
                {children}
            </div>
        </div>
    );
};

export default Filter;
